import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Message } from 'src/app/models/Message';
import { CONSTANTES } from "../shared/global";
import { BehaviorSubject } from 'rxjs';
import { DataMessage } from '../models/DataMessage';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  url: string;
  mensajesNoLeidos = localStorage.getItem("mensajesNoLeidos");

  private countMesagges = new BehaviorSubject(this.mensajesNoLeidos);
  currentMessages = this.countMesagges.asObservable();

  constructor(private http: HttpClient) {
    this.url = CONSTANTES.api_url + "/doubts";

  }

  postContacto(dataMessage: DataMessage) {
    const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post<DataMessage>(this.url + "/info", JSON.stringify(dataMessage), { headers: iheaders });
 
  }

  postConfirmOrder(dataMessage: DataMessage){
    const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post<DataMessage>(this.url + "/infoConfirmOrder", JSON.stringify(dataMessage), { headers: iheaders });
  }
 
}
